'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'bucket';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e4cf';
var svgPathData = 'M224 0c70.7 0 128 57.3 128 128l0 64 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-19.2 0-24.5 244.8-.7 4.5c-4.1 20.8-21.4 36.5-42.5 38.5l-4.6 .2-233.1 0-4.6-.2c-21.1-2-38.4-17.7-42.5-38.5l-.7-4.5-24.5-244.8-19.2 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64C96 57.3 153.3 0 224 0zM91.5 465.6l.6 3c2 6.7 8.2 11.4 15.3 11.4l233.1 0c8.2 0 15.1-6.2 15.9-14.4L380.6 224 67.4 224 91.5 465.6zM224 32c-53 0-96 43-96 96l0 64 192 0 0-64c0-53-43-96-96-96z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBucket = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;